import { APIPaths } from "../api-config";
import BaseApi from "../base-api";

/**
 * 公開申込フォーム（認証なし）のクライアント。
 * accessToken を持たない BaseApi として使う（StoreAuthApi と同じ扱い）。
 */
export class StoreApplicationApi extends BaseApi {
  async postApplicationNew(
    requestBody: APIPaths["/store-app/application/new"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/store-app/application/new"]["post"]["responses"]["201"]["content"]["application/json"]> {
    return (await this.post("/store-app/application/new", requestBody)).data;
  }
  /** 確認メールのトークンを確定して申込を有効化する。確定済みトークンの再送は 200（冪等）。 */
  async postApplicationVerifyEmail(
    requestBody: APIPaths["/store-app/application/verify-email"]["post"]["requestBody"]["content"]["application/json"],
  ): Promise<
    APIPaths["/store-app/application/verify-email"]["post"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.post("/store-app/application/verify-email", requestBody)).data;
  }
}
